import React, { useEffect } from 'react';

export default function NotFound() {
    useEffect(() => {
        const scriptId = 'tailwind-v3-cdn';
        if (!document.getElementById(scriptId)) {
            const script = document.createElement('script');
            script.id = scriptId;
            script.src = 'https://cdn.tailwindcss.com';
            document.head.appendChild(script);
        }
    }, []);

    return (
        <section className="py-10 bg-white min-h-screen flex items-center justify-center font-arvo">
            {/* Import the specific font requested in the original CSS */}
            <style>
                {`
          @import url('https://fonts.googleapis.com/css2?family=Arvo:wght@400;700&display=swap');
          .font-arvo {
            font-family: 'Arvo', serif;
          }
        `}
            </style>

            <div className="container mx-auto px-4 text-gray-800">
                <div className="flex justify-center">
                    <div className="w-full md:w-10/12 text-center">

                        <h1 className="text-[80px] font-bold text-center m-0 pt-8 mb-4">
                            404
                        </h1>

                        {/* Background GIF Section */}
                        <div
                            className="h-[400px] bg-center bg-no-repeat w-full"
                            style={{
                                backgroundImage: 'url(/dribbble_1.gif)'
                            }}
                        >

                        </div>

                        {/* Content Box underneath */}
                        <div className="-mt-[50px] relative z-10">
                            <h3 className="text-4xl font-bold mb-3">
                                Look like you're lost
                            </h3>

                            <p className="text-lg text-gray-600 mb-6">
                                The page you are looking for is not available!
                            </p>

                            <a
                                href="/"
                                className="text-white px-6 py-3 bg-[#39ac31] my-5 inline-block rounded hover:bg-[#2d8827] transition-colors font-medium shadow-md hover:shadow-lg"
                            >
                                Go to Home
                            </a>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
}